import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { AppRouter } from './app-router';
import { AnalyticsConsentController } from './components/analytics-consent-controller';
import { AppShell } from './components/layout/app-shell';
import { NativeAuthCallbackListener } from './components/native-auth-callback-listener';
import { ContextSwitchAnnouncement } from './components/nav/context-switcher';
import { AuthProvider } from './contexts/auth-context';
import { ShellContextProvider } from './contexts/shell-context';
import { queryClient } from './lib/query-client';

/**
 * O `AppShell` envolve o **router inteiro**, e não cada shell.
 *
 * A primeira versão montava-o dentro de `ConsumerShell`/`ProfessionalShell` — mas esses exigem
 * sessão, que só o M1 implementa. O efeito era que `/`, `/login` e o 404, as **únicas** rotas que
 * um visitante alcança hoje, ficavam sem *skip link*, sem `<main>` e sem landmarks.
 *
 * O `axe-core` não apanhou isso: uma página vazia não tem violação nenhuma. Foi o E2E de teclado,
 * ao não encontrar elemento focável, que denunciou. **Acessibilidade do documento não pode depender
 * de estar autenticado** — o `RNF-ACC-01` fala da jornada inteira, e ela começa antes do login.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AnalyticsConsentController />
      {/* O `AuthProvider` envolve o router porque o `AppRouter` já lê a sessão (via `useAuth`)
          para escolher o shell, e os guards dentro das rotas leem o mesmo contexto. Montá-lo por
          dentro daria uma sessão por subárvore. */}
      <AuthProvider>
        <ShellContextProvider>
          <ContextSwitchAnnouncement />
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <NativeAuthCallbackListener />
            <AppShell>
              <AppRouter />
            </AppShell>
          </BrowserRouter>
        </ShellContextProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
